export default __webpack_public_path__ + "static/media/brainstorming.747a1137.svg";